// invokeFunction throws on a non-2xx edge-function response; the JSON body the
// function returned survives only on the thrown FunctionsHttpError's `context`
// Response (same pattern as DeleteMerchantDangerZone.readProblemDetails).

export async function readFunctionErrorBody<T = Record<string, unknown>>(error: unknown): Promise<T | null> {
  const context = (error as { context?: unknown } | null)?.context;
  if (!(context instanceof Response)) return null;
  try {
    return (await context.clone().json()) as T;
  } catch {
    return null;
  }
}
